import { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";

import notification, {
    Error as notificationError,
} from "../../../Modules/Notifications";

import confirm from "../../../Modules/AlertConfirm";

import api from "../../../service/api";

import useLoading from "../../../hooks/useLoading";

function useGraphicMaterial() {
    const { id } = useParams();

    const history = useHistory();

    const { loading } = useLoading();

    const [nome, setNome] = useState("");
    const [imagem, setImagem] = useState({});
    const [arquivo, setArquivo] = useState([]);

    const show = useCallback(() => {
        async function show() {
            const idLoading = loading();

            try {
                const response = await api.get(`/materiais-graficos/${id}`);

                const data = response.data;

                setNome(data.nome);

                const imagem = {
                    id: response.data.imagem.id,
                    preview: `${api.defaults.baseURL}${response.data.imagem.url}`,
                };

                setImagem(imagem);

                setArquivo(data.arquivo);

                loading(idLoading);
            } catch (error) {
                notificationError(error);

                loading(idLoading);
            }
        }

        show();
    }, [id, loading]);

    useEffect(() => {
        if (id) show();
    }, [show, id]);

    function handleOnChangeNome({ target }) {
        const { value } = target;

        setNome(value);
    }

    const uploadFile = async (file) => {
        const idLoading = loading();

        let data = new FormData();
        data.append(`files`, file);
        const response = await api.post("/upload", data);

        loading(idLoading);

        return response.data[0];
    };

    function handleOnChangeImagem(files) {
        const file = files[0];

        if (imagem.id) {
            confirm(
                "Alterar Imagem",
                "Tem certeza que deseja alterar ?",
                async () => {
                    const idLoading = loading();

                    try {
                        await api.delete(`/upload/files/${imagem.id}`);
                        const response = await uploadFile(file);
                        await api.put(`/materiais-graficos/${id}`, {
                            imagem: response,
                        });

                        show();
                        notification("success", "Imagem alterada");

                        loading(idLoading);
                    } catch (error) {
                        notificationError(error);

                        loading(idLoading);
                    }
                }
            );
        } else {
            setImagem({
                file,
                preview: URL.createObjectURL(file),
            });
        }
    }

    function handleOnDeleteImagem() {
        if (imagem.id) {
            notification("warning", "Não é possivel remover");
        } else {
            setImagem({});
        }
    }

    function handleOnChangeArquivo(value) {
        setArquivo(value);
    }

    async function update(id, data) {
        const idLoading = loading();

        try {
            await api.put(`/materiais-graficos/${id}`, data);

            notification("success", "Material Gráfico alterado");

            loading(idLoading);
        } catch (error) {
            notificationError(error);

            loading(idLoading);
        }
    }

    function destroy() {
        confirm(
            "Remover Material Gráfico",
            "Tem certeza que deseja remover ?",
            async () => {
                const idLoading = loading();

                try {
                    await api.delete(`/materiais-graficos/${id}`);
                    notification("success", "Material Gráfico removido");
                    history.push("/ctop/materiais-graficos");

                    loading(idLoading);
                } catch (error) {
                    notificationError(error);

                    loading(idLoading);
                }
            }
        );
    }

    function handleValidate() {
        if (!nome) {
            return { status: false, message: "Nome é obrigatório" };
        }

        if (Object.keys(imagem).length === 0) {
            return { status: false, message: "Imagem é obrigatório" };
        }

        if (Object.keys(arquivo).length === 0) {
            return { status: false, message: "Arquivo é obrigatório" };
        }

        return { status: true };
    }

    async function create(data) {
        const idLoading = loading();

        try {
            await api.post("/materiais-graficos", data);

            notification("success", "Material Gráfico cadastrado");

            loading(idLoading);
        } catch (error) {
            notificationError(error);

            loading(idLoading);
        }
    }

    async function handleOnSubmit(event) {
        try {
            event.preventDefault();

            const validate = handleValidate();
            if (!validate.status) {
                return notification("warning", validate.message);
            }

            if (!imagem.id) {
                var uploadedImagem = await uploadFile(imagem.file);
            }

            if (!id) {
                await create({
                    nome,
                    imagem: uploadedImagem,
                    arquivo,
                });
            } else {
                await update(id, { nome, arquivo });
            }

            history.push("/ctop/materiais-graficos");
        } catch (error) {
            notificationError(error);
        }
    }

    return {
        nome,
        imagem,
        arquivo,
        handleOnChangeNome,
        handleOnChangeImagem,
        handleOnDeleteImagem,
        handleOnChangeArquivo,
        destroy,
        handleOnSubmit,
    };
}

export default useGraphicMaterial;
